import { render } from "./SignaturesStart.vue?vue&type=template&id=3331cd34"
import script from "./SignaturesStart.vue?vue&type=script&lang=js"
export * from "./SignaturesStart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__